import { render } from "./ListLoader.vue?vue&type=template&id=77c9b7f1"
import script from "./ListLoader.vue?vue&type=script&lang=js"
export * from "./ListLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__